"use client";

import { useRouter } from "next/navigation";
import { FolderIcon } from "@/components/icons";
import { SidebarSectionHeader } from "./SidebarSectionHeader";

/** Workers heading and the action to organize them into departments. */
export function AutomationControls({
  activeBusiness,
  onNewDepartment,
  onCloseDrawer,
}: {
  activeBusiness: string;
  onNewDepartment: () => void;
  onCloseDrawer: () => void;
}) {
  const router = useRouter();
  return <SidebarSectionHeader actions={<>
    <button
      type="button"
      title="New department"
      onClick={() => onNewDepartment()}
      disabled={!activeBusiness}
      className="flex size-6 cursor-pointer items-center justify-center rounded text-zinc-500 transition hover:text-zinc-200 disabled:cursor-default disabled:opacity-40"
    >
      <FolderIcon className="size-3.5" />
    </button>
    <button type="button" title="New worker" aria-label="New worker" disabled={!activeBusiness}
      onClick={() => { onCloseDrawer(); router.push("/workers/new"); }}
      className="flex size-6 cursor-pointer items-center justify-center rounded text-sm leading-none text-zinc-500 transition hover:text-zinc-200 disabled:cursor-default disabled:opacity-40">+</button>
  </>}>Workers</SidebarSectionHeader>;
}
